if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.lg-faq__question'));
      this.handleClick = this.handleClick.bind(this);
      this.buttons.forEach(btn => btn.addEventListener('click', this.handleClick));
    }

    disconnectedCallback() {
      this.buttons.forEach(btn => btn.removeEventListener('click', this.handleClick));
    }

    handleClick(e) {
      const btn = e.currentTarget;
      const panelId = btn.getAttribute('aria-controls');
      const panel = this.querySelector('#' + panelId);
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      this.buttons.forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        const p = this.querySelector('#' + b.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });

      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        if (panel) panel.hidden = false;
      }
    }
  });
}
